import React, { useState } from "react";
import { Box, Modal, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import CloseIcon from "@mui/icons-material/Close";

const ImageMessage = ({ url, alt }) => {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [isHovering, setIsHovering] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleDownload = (e) => {
        e.stopPropagation();
        const link = document.createElement("a");
        link.href = url;
        link.download = alt;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                borderRadius: "8px",
                justifyContent: "flex-start",
                pl: 2,
                width: "100%",
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                    backgroundColor: theme.palette.primary[50],
                    borderRadius: "5%",
                    padding: 1,
                }}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onClick={handleOpen}
            >
                <img
                    src={url}
                    alt="AI Generated"
                    style={{
                        maxWidth: "150px",
                        borderRadius: "8px",
                        cursor: "pointer",
                    }}
                />
                {isHovering && (
                    <IconButton
                        onClick={handleDownload}
                        sx={{
                            position: "absolute",
                            right: 5,
                            top: 5,
                            // backgroundColor: "rgba(255, 255, 255, 0.7)",
                            "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                            },
                            color: (theme) => theme.palette.primary.main,
                        }}
                    >
                        <DownloadForOfflineIcon />
                    </IconButton>
                )}
            </Box>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="image-preview-modal"
                aria-describedby="image-preview-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                        maxWidth: "90vw",
                        maxHeight: "90vh",
                        borderRadius: "8px",
                        overflow: "hidden",
                    }}
                >
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 2,
                            top: 2,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <img
                        src={url}
                        alt={alt}
                        style={{
                            maxWidth: "100%",
                            maxHeight: "80vh",
                            objectFit: "contain",
                        }}
                    />
                </Box>
            </Modal>
        </Box>
    );
};

export default ImageMessage;
